export default "__VITE_ASSET__C7o8ABCk__"